import { render, staticRenderFns } from "./actions-horizontal.vue?vue&type=template&id=4a05aaf3&"
import script from "./actions-horizontal.vue?vue&type=script&lang=js&"
export * from "./actions-horizontal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports